import type { DataSourceAbstract, RichTextContentProtocol } from '@lighthouse/core'
import type { VariableDropDownOption } from '@lighthouse/shared'
import { getInputInnerTypeMatch, NodeFieldPreview } from '@lighthouse/shared'
import React, { useCallback } from 'react'

import * as SC from './styles'

type WechatTemplateContentValue = {
    variableName: string
    value: RichTextContentProtocol
}[]

interface ContentSettingProps extends VariableDropDownOption {
    value?: WechatTemplateContentValue
    onChange: (val: WechatTemplateContentValue) => void
    dataSourceList?: DataSourceAbstract[]
}

export const ContentSetting: React.FC<ContentSettingProps> = ({ value, onChange, ...restOptions }) => {
    const handleChange = useCallback(
        (val: RichTextContentProtocol, i: number) => {
            if (!value) {
                return
            }
            const newValue = value.map((item, index) => {
                if (index === i) {
                    return {
                        variableName: item.variableName,
                        value: val
                    }
                }
                return item
            })
            onChange(newValue)
        },
        [onChange, value]
    )

    return (
        <>
            {value?.map((item, index) => (
                <SC.VariableItem style={{ marginTop: 8 }} key={item.variableName}>
                    <SC.VariableTitle>{`${item.variableName}`}</SC.VariableTitle>
                    <NodeFieldPreview
                        innerTypes={getInputInnerTypeMatch('TEXT')}
                        placeholder="请输入"
                        value={item.value}
                        onBlur={val => handleChange(val, index)}
                        autoHeight
                        {...restOptions}
                    />
                </SC.VariableItem>
            ))}
        </>
    )
}
